// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/styles/tattva_cta.css
// module id = 6461
// module chunks = 0